export const appConfig = {
	API_KEY: '398985eb-4255-4493-8c11-1485e18de5ee'
};
